/**
 * Vaccine Explorer — shared utilities for public pages.
 *
 * Single source of truth for age cohort slugs/labels/orderings so the
 * by-age cohort URLs are stable, indexable and consistent between admin
 * (which stores age_months) and public (which builds /by-age/<slug>).
 *
 * Extending to a new cohort? Add one row and every page picks it up.
 */

export const AGE_COHORTS = [
    { slug: "birth", label: "Birth", months: 0 },
    { slug: "8-weeks", label: "8 weeks", months: 2 },
    { slug: "12-weeks", label: "12 weeks", months: 3 },
    { slug: "16-weeks", label: "16 weeks", months: 4 },
    { slug: "12-months", label: "12 months", months: 12 },
    { slug: "12-15-months", label: "12–15 months", months: 12 },
    { slug: "3-years-4-months", label: "3 years 4 months", months: 40 },
    { slug: "4-6-years", label: "4–6 years", months: 48 },
    { slug: "14-years", label: "14 years", months: 168 },
    { slug: "16-18-years", label: "16–18 years", months: 192 },
];

export function cohortBySlug(slug) {
    return AGE_COHORTS.find((c) => c.slug === slug) || null;
}

export function cohortByMonths(months) {
    return AGE_COHORTS.find((c) => c.months === months) || null;
}

export const COUNTRIES = [
    { code: "UK", label: "United Kingdom", regulator: "NHS / MHRA" },
    { code: "US", label: "United States", regulator: "CDC / FDA" },
];

export function countryByCode(code) {
    return COUNTRIES.find((c) => c.code === (code || "").toUpperCase()) || null;
}
